import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiReact,
  SiBootstrap,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://camo.githubusercontent.com/deb61a8df3a234e94a3e54ad06fd30ddf1a756e9185a3e923e0f3f4669f9dd3c/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313430302f312a5a7577635f72355265694943332d6f625663335257772e6a706567"
                    alt="Beardo"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Beardo</h2>
                <p>
                A E-Commerce website for selling products related to male gromming.

                </p>
                <div>
                  <SiNodedotjs />
                  <SiExpress />
                  <SiMongodb />
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://beardo-project.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/15VIKRANT/Beardo-Clone.git"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://i.postimg.cc/3JZYKkDd/Screenshot-10.png"
                    alt="Sephora"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Beauty Bebo Clone</h2>
                <p>
                A E-commerce website for selling cosmetics 
                products
                </p>
                <div>
                 
                 <SiReact/>
                 <SiMongodb />
                 <SiBootstrap/>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://serene-naiad-8e1b8f.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/15VIKRANT/SEPHORA.git"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
     
       
        </div>
      </div>
      
    </>
  );
};
